export default "__VITE_ASSET__C8_P8i3P__"